module.exports = __webpack_public_path__ + "img/Illegal_building-0.a9780194.jpg";